import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Card, SpeedDial, SpeedDialIcon } from "@mui/material";
import { styled } from "@mui/material/styles";
import api from "../../../components/services/api";
import { DataGrid } from "@mui/x-data-grid";
import DialogAddShip from "../components/DialogAddShip";
import moment from "moment";
import { Box } from "@mui/system";
import DialogEditShip from "../components/DialogEditShip";
import SearchData from "../components/SearchData";
import { useSelector } from "react-redux";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DeleteIcon from "@mui/icons-material/Delete";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import TextField from "@mui/material/TextField";
import SearchIcon from '@mui/icons-material/Search';
import mime from "mime";
import { saveAs } from "file-saver";

export default function ShipSchedule() {
  const [data, setData] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [dateStart, setDateStart] = useState(moment().format('yyyy-MM-DD'));
  const [dateEnd, setDateEnd] = useState(moment().add(1, "M").format('yyyy-MM-DD'));
  const [checkAll, setCheckAll] = useState(true);

  const [loading, setLoading] = useState(false)
  const [searchText, setSearchText] = useState('')
  const [search, setSearch] = useState({
    startDate: dateStart,
    endDate: dateEnd,
    voyNo: ''
  })
  const [open, setOpen] = useState(false);
  const [openDiaolgEdit, setOpenDiaolgEdit] = useState(false);
  const [IdEdit, setIdEdit] = useState("");
  const [dataPropsEdit, setDataPropsEdit] = useState("");
  const MenuActive = useSelector((state) => state.MenuActive.List);
  const [selected, setSelectedRows] = useState([]);
  const SearchDate = (startdate, enddate) => {
    const newData = data.filter((x) => {
      return new Date(x.ETDIn) >= startdate && new Date(x.ETDIn) <= enddate;
    });

    setDataFilter(newData);
  };
  const handledelete = () => {
    const data = {
      ids: selected.map((e) => e.idScheduleServiceShip),
    };

    api.post(`api/ship/delete`, data).then((res) => {

      ShipScheduleList();

    });
  };
  /* table data */
  const columns = [
    { field: "BargeName", headerName: "BARGE", width: 150 },
    { field: "TugName", headerName: "TUG", width: 150 },
    { field: "VoyageIn", headerName: "VOY", width: 150 },
    {
      field: "LocFrom",
      headerName: "FROM - TO",
      width: 200,
      renderCell: (params) => {
        return (
          <div>
            <span>
              {params?.row?.LocFrom} - {params?.row?.LocTo}
            </span>
          </div>
        );
      },
    },
    {
      field: "ETDIn",
      headerName: "ETD",
      width: 150,
      valueFormatter: ({ value }) => {
        return moment(value).format("DD-MM-YYYY HH:mm");
      },
    },
    {
      field: "ETAIn",
      headerName: "ETA",
      width: 150,
      valueFormatter: ({ value }) => {
        return moment(value).format("DD-MM-YYYY HH:mm");
      },
    },




    { field: "VoyageOut", headerName: "VOY", width: 150 },
    {
      field: "LocTo",
      headerName: "FROM - TO",
      width: 200,
      renderCell: (params) => {
        return (
          <div>
            <span>
              {params?.row?.LocTo} - {params?.row?.LocFrom}
            </span>
          </div>
        );
      },
    },
    {
      field: "ETDOut",
      headerName: "ETD",
      width: 150,
      valueFormatter: ({ value }) => {
        return moment(value).format("DD-MM-YYYY HH:mm") == 'Invalid date' ? '-' : moment(value).format("DD-MM-YYYY HH:mm");
      },
    },
    {
      field: "ETAOut",
      headerName: "ETA",
      width: 150,
      valueFormatter: ({ value }) => {
        return moment(value).format("DD-MM-YYYY HH:mm") == 'Invalid date' ? '-' : moment(value).format("DD-MM-YYYY HH:mm");
      },
    },




    {
      field: "Action",
      width: 150,
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <Link
              to={{
                pathname: `/Planner/EditShipSchedule/${params.id}`,
              }}
            >
              <Button
                variant="contained"
                style={{ textTransform: "none", backgroundColor: "#007BFF" }}
              >
                View
              </Button>
            </Link>

            <Button
              variant="contained"
              style={{
                textTransform: "none",
                backgroundColor: "#007BFF",
                margin: 5,
              }}
              onClick={() => {
                setDataPropsEdit(params);
                setIdEdit(params?.id);
                setOpenDiaolgEdit(true);
              }}
            >
              Edit
            </Button>
          </>
        );
      },
    },
  ];

  //Floating Button
  const floating_action_style = {
    margin: 0,
    top: "auto",
    right: 20,
    bottom: 0,
    left: "auto",
    position: "fixed",
  };

  const ShipScheduleList = async () => {
    try {
      const result = await api.get(`api/ship/list?startDate=${search.startDate}&endDate=${search.endDate}&voyNo=${search.voyNo}`);
      setData(result?.data);
      setDataFilter(result?.data);
      // console.log(result);
    } catch (error) {
      console.log("error => ", error);
    }
  };

  useEffect(() => {
    ShipScheduleList();
  }, [search]);

  const handleClose = (props) => {
    setOpen(props);
    setOpenDiaolgEdit(props);
  };


  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
          <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
            ตารางการเดินเรือ
          </h6>

          <Grid container alignItems="center" spacing={1}>
            <Grid item xs>
              <Typography
                className="textcolordarkblue"
                variant="h5"
                component="h1"
              >
                Ship Schedule
              </Typography>
            </Grid>
            <Grid item sx={{ display: "flex", flexDirection: "row" }}>
              <Typography className="textcolorBule">Ship</Typography>
              <Typography>
                <span>&nbsp;</span> / Ship Schedule
              </Typography>
            </Grid>
          </Grid>

          <Grid
            style={{
              marginTop: "16px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
            spacing={2}
          >
            <div style={{ display: "flex", alignItems: "flex-end" }}>
              <Button

                onClick={handledelete}
                style={{
                  backgroundColor: "red",
                  height: "35px",
                  width: "15px",
                  color: "#fafafa",
                  marginRight: "10px"
                }}
              >
                <DeleteIcon />
              </Button>
              <Button
                variant="outlined"
                style={{ color: "#84BD5A", borderColor: "#84BD5A" }}

                onClick={async () => {
                  setLoading(true)
                  await api.get(`api/report/shipschedule/download?sdate=${search.startDate}&edate=${search.endDate}&format=xlsx`, {
                    responseType: "blob",
                    timeout: 30000
                  })
                    .then((blobFile) => {
                      const blobFileRes = new File([blobFile?.data], "test.xlsx", {
                        type: mime.getType(".xlsx"),

                      });

                      // window.open(
                      //   URL.createObjectURL(blobFileRes, "test.csv"),
                      //   "_blank"
                      // );
                      saveAs(blobFileRes, "Report.xlsx");
                      setLoading(false)
                    });

                }}
              >
                <span className="material-icons-outlined">description</span>
                Export
              </Button>

            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <TextField value={searchText} onChange={e => setSearchText(e.target.value)} size="small" id="outlined-basic" label="Search Voy" variant="outlined" />



              <DesktopDatePicker
                label="Date Start"
                value={dateStart}
                inputFormat='yyyy/MM/dd'
                minDate={new Date("2017-01-01")}
                onChange={async (newValue) => {
                  setDateStart(newValue);
                  setCheckAll(false);
                  await SearchDate(newValue, dateEnd);
                }}
                renderInput={(params) => (
                  <TextField size="small" style={{ width: "200px", marginLeft: "10px" }} {...params} />
                )}
              />
              <DesktopDatePicker
                label="Date End"
                value={dateEnd}
                inputFormat='yyyy/MM/dd'
                minDate={new Date(dateStart)}
                onChange={async (newValue) => {
                  setDateEnd(newValue);
                  setCheckAll(false);
                  await SearchDate(dateStart, newValue);
                }}
                renderInput={(params) => (
                  <TextField size="small"
                    style={{ width: "200px", marginLeft: "10px" }}
                    {...params}
                  />
                )}
              />
              <Button
                style={{
                  backgroundColor: "#0d6efd",
                  color: "#fafafa",
                  marginLeft: "10px"
                }}
                onClick={() => setSearch({
                  startDate: moment(dateStart).format('yyyy-MM-DD'),
                  endDate: moment(dateEnd).format('yyyy-MM-DD'),
                  voyNo: searchText
                })}
              >
                <SearchIcon />
              </Button>
            </div>
          </Grid>

          <Box
            sx={{
              height: 650,
              width: "100%",
              marginTop: "30px",
              '& .MuiDataGrid-cell--withRenderer':{
                width:'100%',
                backgroundColor:"#fff",
                position:"sticky",
                right:'0'
              }
            }}
          >
            <DataGrid
              getRowId={(r) => r.idScheduleServiceShip}
              rows={data}
              columns={columns}
              pageSize={10}
              rowsPerPageOptions={[10]}
              hideFooterSelectedRowCount
              disableColumnFilter
              disableColumnMenu
              checkboxSelection
              onSelectionModelChange={(ids) => {
                const selectedIDs = new Set(ids);
                const selectedRows = dataFilter.filter((row) =>
                  selectedIDs.has(row?.idScheduleServiceShip?.toString())
                );

                setSelectedRows(selectedRows);
              }}
            />
          </Box>
        </Card>
      </LocalizationProvider>
      {MenuActive.find(
        (x) => x.ActionNo === "A031" || x.ActionNo === "A046"
      ) && (
          <SpeedDial
            ariaLabel="SpeedDial basic example"
            sx={{ position: "absolute", bottom: 16, right: 16 }}
            icon={<SpeedDialIcon />}
            onClick={() => setOpen(true)}
          />
        )}
      <DialogAddShip DialogAdd={open} DialogAddClose={handleClose} ShipScheduleList={ShipScheduleList} />
      <DialogEditShip
        DialogEdit={openDiaolgEdit}
        onSuccess={ShipScheduleList}
        idEdit={IdEdit}
        dataprops={dataPropsEdit}
        DialogEditClose={handleClose}
        ShipScheduleList={ShipScheduleList}
      />
    </div>
  );
}
